import { render, staticRenderFns } from "./ViewerShortcuts.vue?vue&type=template&id=74802eae"
import script from "./ViewerShortcuts.vue?vue&type=script&lang=js"
export * from "./ViewerShortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports